import React, { useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import { useAlert } from "react-alert";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import {
  Details,
  InfoText,
  Title,
  FormContainer,
  FormTitle,
  InputField,
  SumbitButton,
} from "./contact.components";
import MapImage from "../../images/map.png";
import { saveUserQuery } from "../../services/query";
import QueryConfirmationDialog from "../dialog/queryConfirmationDialog";

function Contact() {
  const alert = useAlert();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const handleSubmit = async () => {
    if (validate()) {
      const queryData = {
        name: name,
        phone: phone,
        emailID: email,
        message: message,
      };
      await saveUserQuery(queryData)
        .then((response) => {
          if (response.status === 200) {
            setOpen(true);
            setName("");
            setPhone("");
            setEmail("");
            setMessage("");
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <>
      <QueryConfirmationDialog open={open} setOpen={setOpen} />
      <OuterWrapper sx={{ bgcolor: "#F8FBFE" }}>
        <InnerWrapper>
          <Grid container sx={{ width: "100%", height: 260 }}>
            <InfoText sx={{ px: { xs: 1.25, md: 0 } }}>
              Have a little something you want to talk to us about ? Well give
              us a ring. Send us a email or fill out that form below and we will
              get back to you as soon as we can.
            </InfoText>
          </Grid>
        </InnerWrapper>
      </OuterWrapper>
      <OuterWrapper sx={{ bgcolor: "#EAEEF2" }}>
        <InnerWrapper>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "center", md: "flex-start" }}
          >
            <CompanyDetails />
            {ContactForm()}
          </Stack>
        </InnerWrapper>
      </OuterWrapper>
    </>
  );

  function CompanyDetails() {
    return (
      <Stack
        direction="column"
        spacing={6}
        sx={{
          width: { xs: "95%", md: "46%" },
          borderRight: { md: "5px solid #F8FBFE" },
          pb: 5.25,
          pr: { md: "45px" },
        }}
      >
        <Title sx={{ width: { xs: "100%", md: 300 } }}>Xpverse Pvt Ltd</Title>
        <Details>
          #20th Main, Whitefield
          <br /> Bangalore, India
          <br /> 560037
          <br />
          <Details component="a" href="mailto:apnicompany@gmail.com">
            Apnicompany@gmail.com
          </Details>
          <br /> 123456789 | 9876543210
        </Details>
        <Box component="img" src={MapImage} alt="" />
      </Stack>
    );
  }

  function ContactForm() {
    return (
      <FormContainer
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2.5}
        sx={{
          width: { xs: "95%", md: 500 },
          mt: 1,
          mb: 5.25,
          m: { md: "auto" },
        }}
      >
        <FormTitle>
          Have a more specific query, <br /> Reach out to us now.
        </FormTitle>
        <InputField
          component="input"
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InputField
          component="input"
          type="text"
          placeholder="Phone No"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <InputField
          component="input"
          type="email"
          placeholder="Email id"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <InputField
          txtArea="100px"
          component="textarea"
          placeholder="Type your message here"
          value={message}
          sx={{ py: 3 }}
          onChange={(e) => setMessage(e.target.value)}
        />
        <SumbitButton onClick={handleSubmit}>send</SumbitButton>
      </FormContainer>
    );
  }

  function validate() {
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

    if (!name) {
      alert.error("please enter the name");
      return false;
    }
    if (!phone || !phoneRegex.test(phone)) {
      alert.error("please enter a valid phone number");
      return false;
    }
    if (!email || !emailRegex.test(email)) {
      alert.error("please enter a valid email id");
      return false;
    }
    if (!message) {
      alert.error("please enter the message");
      return false;
    }
    return true;
  }
}

export default Contact;
